import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = ['siteConfigId'];

  enable() {
    this.updateEnabledValue(true);
  }

  disable() {
    this.updateEnabledValue(false);
  }

  updateEnabledValue(value) {
    const siteConfigId = this.siteConfigIdTarget.value;
    const requestUrl = `/api/siteconfigs/${siteConfigId}/value`;
    const requestBody = { value };
    callApi(requestUrl, 'PUT', requestBody)
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$sendAlert(err.msg);
      });
  }
}
